import Loadable from '@/common/presentation/components/utils/Loader/Loadable';
import RouteErrorElement from '@/common/presentation/components/utils/RouteErrorElement';
import { lazy } from 'react';
import { ClientProvider } from '@/common/application/contexts/ClientContext';
import { Outlet } from 'react-router-dom';

const OneTimePaymentPage = Loadable(lazy(() => import('../presentation/pages/OneTimePaymentPage')));
const OneTimePaymentPreviewPage = Loadable(lazy(() => import('../presentation/pages/OneTimePaymentPreview')));
const LinkPage = Loadable(lazy(() => import('../presentation/pages/LinkPage')));
const OneTimePaymentConfirmationPage = Loadable(lazy(() => import('../presentation/pages/OneTimeConfirmationPage')));
const NonInvoicePaymentPage = Loadable(lazy(() => import('../presentation/pages/NonInvoicePaymentPage')));
// Cross-feature presentation import (not domain/infrastructure), deliberate — see
// src/document-link/README.md and LLAMS-562 Part 3's layering note: keeping every /link/* path in
// one routes file is why this lives here rather than under a dedicated DocumentLinkRoutes.
const DocumentLinkPage = Loadable(lazy(() => import('@/document-link/presentation/pages/DocumentLinkPage')));

const OneTimePaymentRoutes = {
  //path: 'one-time-payment',
  element: (
    <ClientProvider>
      <Outlet />
    </ClientProvider>
  ),
  // Covers every /link/* child below: a render or loader throw shows a branded message instead of
  // a blank page. Not yet attached to AuthRoutes/MainRoutes — see LLAMS-562 Part 3 PR description.
  errorElement: <RouteErrorElement />,
  children: [
    {
      path: 'link/:token',
      element: <LinkPage />,
    },
    {
      path: 'link/preview',
      element: <OneTimePaymentPreviewPage />,
    },
    {
      path: 'link/one-time-payment',
      element: <OneTimePaymentPage />,
    },
    {
      path: 'link/confirmation',
      element: <OneTimePaymentConfirmationPage />,
    },
    {
      path: 'link/non-invoice-payment',
      element: <NonInvoicePaymentPage />,
    },
    // Three segments, deliberately: react-router ranks a static segment above a dynamic one, so a
    // two-segment `link/document` would shadow `link/:token` for the literal token "document". The
    // token stays in the URL (not router state) because it is the recipient's only credential.
    {
      path: 'link/document/:token',
      element: <DocumentLinkPage />,
    },
  ],
};

export default OneTimePaymentRoutes;